<template>
  <div class="section-one">
    <div class="container">
      <div class="row vertical-desktop">
        <div class="logo-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 371.73 120.99"><g id="logo-layer" data-name="Layer 2"><g id="Type_logos" data-name="Type/logos"><path class="logo" d="M41.75,119.65V103.53a1.25,1.25,0,0,1,.4-1,1.38,1.38,0,0,1,.94-.36h6.73a4.66,4.66,0,0,1,4.67,4.69v1.33a4.54,4.54,0,0,1-1.41,3.38A4.51,4.51,0,0,1,54.49,115v1.35A4.66,4.66,0,0,1,49.82,121H43.09a1.35,1.35,0,0,1-.94-.36A1.22,1.22,0,0,1,41.75,119.65Zm2.68-9.4h5.39a1.93,1.93,0,0,0,1.41-.6,2,2,0,0,0,.58-1.44v-1.33a2,2,0,0,0-2-2H44.43Zm0,8.06h5.39a2,2,0,0,0,1.41-.59,1.92,1.92,0,0,0,.58-1.41V115a2,2,0,0,0-2-2H44.43Z"/><path class="logo" d="M81.39,102.71a1.7,1.7,0,0,1,.66-.44.92.92,0,0,1,.41-.1,1.33,1.33,0,0,1,.38.07,1.35,1.35,0,0,1,.73.53l3.91,6.28,3.91-6.28a1.39,1.39,0,0,1,.73-.53,1.33,1.33,0,0,1,.38-.07,1,1,0,0,1,.42.1,1.7,1.7,0,0,1,.66.44,1,1,0,0,1,.31.73v0a1.57,1.57,0,0,1-.25.82L88.82,112v7.64a1.26,1.26,0,0,1-.42,1,1.37,1.37,0,0,1-1.85,0,1.28,1.28,0,0,1-.41-1V112l-4.82-7.69a1.56,1.56,0,0,1-.24-.82A1,1,0,0,1,81.39,102.71Z"/><path class="logo" d="M159.81,116.28a1.21,1.21,0,0,1,.42-1,1.4,1.4,0,0,1,1.85,0,1.24,1.24,0,0,1,.41,1,1.93,1.93,0,0,0,.6,1.43,2,2,0,0,0,1.44.6h3.35a1.93,1.93,0,0,0,1.42-.59,2,2,0,0,0,.58-1.44,2,2,0,0,0-.56-1.37,5.12,5.12,0,0,0-1.44-1.08c-.59-.31-1.25-.61-2-.92s-1.43-.63-2.14-1a14.49,14.49,0,0,1-2-1.19,5,5,0,0,1-1.44-1.63,4.35,4.35,0,0,1-.56-2.19,4.58,4.58,0,0,1,1.38-3.34,4.5,4.5,0,0,1,3.32-1.38h3.37a4.47,4.47,0,0,1,3.31,1.37,4.53,4.53,0,0,1,1.37,3.32,1.24,1.24,0,0,1-.42,1,1.39,1.39,0,0,1-.92.36,1.37,1.37,0,0,1-.92-.36,1.24,1.24,0,0,1-.42-1,2,2,0,0,0-.59-1.42,1.93,1.93,0,0,0-1.41-.59h-3.37a1.92,1.92,0,0,0-1.42.6,2,2,0,0,0-.6,1.44,2,2,0,0,0,.56,1.36,4.77,4.77,0,0,0,1.44,1.08c.6.31,1.25.61,2,.91s1.42.63,2.14,1a14.37,14.37,0,0,1,2,1.19,5.33,5.33,0,0,1,1.45,1.64,4.41,4.41,0,0,1,.55,2.2,4.57,4.57,0,0,1-1.37,3.33,4.48,4.48,0,0,1-3.31,1.38h-3.35a4.73,4.73,0,0,1-4.72-4.71Z"/><path class="logo" d="M199.17,116.26v-9.38a4.68,4.68,0,0,1,4.69-4.69h3.38a4.66,4.66,0,0,1,4.67,4.69v9.38a4.55,4.55,0,0,1-1.36,3.32,4.49,4.49,0,0,1-3.31,1.38h-3.38a4.52,4.52,0,0,1-3.32-1.38A4.56,4.56,0,0,1,199.17,116.26Zm2.68,0a2,2,0,0,0,.59,1.43,2,2,0,0,0,1.42.59h3.38a2,2,0,0,0,2-2v-9.38a2,2,0,0,0-2-2h-3.38a2,2,0,0,0-2,2Z"/><path class="logo" d="M238.52,116.23v-12.7a1.23,1.23,0,0,1,.42-1,1.4,1.4,0,0,1,1.85,0,1.25,1.25,0,0,1,.41,1v12.7a1.94,1.94,0,0,0,.6,1.43,1.92,1.92,0,0,0,1.42.6h3.37a1.9,1.9,0,0,0,1.41-.6,2,2,0,0,0,.59-1.43v-12.7a1.23,1.23,0,0,1,.42-1,1.38,1.38,0,0,1,1.84,0,1.23,1.23,0,0,1,.42,1v12.7a4.57,4.57,0,0,1-1.37,3.33,4.47,4.47,0,0,1-3.31,1.37h-3.37a4.49,4.49,0,0,1-3.32-1.37A4.54,4.54,0,0,1,238.52,116.23Z"/><path class="logo" d="M277.88,119.65V103.53a1.22,1.22,0,0,1,.49-1.08,1.32,1.32,0,0,1,.73-.22,1.48,1.48,0,0,1,.41,0,1.57,1.57,0,0,1,1,.72l7.46,12V103.53a1.26,1.26,0,0,1,.42-1,1.37,1.37,0,0,1,1.85,0,1.28,1.28,0,0,1,.41,1v16.12a1.21,1.21,0,0,1-.5,1.08,1.27,1.27,0,0,1-.71.22,1.74,1.74,0,0,1-.39,0,1.63,1.63,0,0,1-1-.71l-7.5-12v11.46a1.19,1.19,0,0,1-.41,1,1.37,1.37,0,0,1-1.85,0A1.19,1.19,0,0,1,277.88,119.65Z"/><path class="logo" d="M317.23,119.63v-16.1a1.38,1.38,0,0,1,1.35-1.34h6.72a4.47,4.47,0,0,1,3.31,1.37,4.53,4.53,0,0,1,1.37,3.32v9.35a4.57,4.57,0,0,1-1.37,3.33,4.47,4.47,0,0,1-3.31,1.37h-2.1v0h-4.62a1.28,1.28,0,0,1-.94-.4A1.25,1.25,0,0,1,317.23,119.63Zm2.68-1.35h3.25v0h2.14a1.91,1.91,0,0,0,1.41-.6,2,2,0,0,0,.59-1.43v-9.35a2,2,0,0,0-.59-1.42,1.94,1.94,0,0,0-1.41-.59h-5.39Z"/><rect class="logo" y="0.09" width="11.8" height="58.67"/><rect class="logo" x="40.18" y="0.09" width="11.8" height="58.67"/><rect class="logo" x="20.09" y="5.9" width="11.8" height="44.11" transform="translate(53.94 1.96) rotate(90)"/><rect class="logo" x="128.64" y="-13.16" width="11.8" height="38.3" transform="translate(140.54 -128.55) rotate(90)"/><rect class="logo" x="128.64" y="33.71" width="11.8" height="38.3" transform="translate(187.4 -81.68) rotate(90)"/><rect class="logo" x="230.48" y="35.34" width="11.8" height="35.04" transform="translate(289.25 -183.52) rotate(90)"/><rect class="logo" x="127.72" y="10.33" width="11.8" height="36.46" transform="translate(162.18 -105.07) rotate(90)"/><polygon class="logo" points="127.2 57.97 115.4 58.76 115.4 0.09 127.2 0.86 127.2 57.97"/><rect class="logo" x="218.86" y="0.09" width="11.8" height="58.67"/><rect class="logo" x="317.39" y="0.09" width="11.8" height="58.67"/><path class="logo" d="M332.73,58.89c-3.46,0-6.82-.2-9.91-.51l.95-9.78c15.37,1.49,27.12-.68,33.11-6.11,3.37-3.07,5-7.21,5-12.68,0-6.1-1.7-10.61-5.19-13.78-5.83-5.3-16.92-7.22-32.94-5.69L322.83.55c19.17-1.82,32.41.86,40.49,8.2,5.58,5.07,8.41,12.16,8.41,21.06,0,8.28-2.78,15-8.25,20C355.63,56.89,343.66,58.89,332.73,58.89Z"/><path class="logo" d="M355.34,14.93c8.65,6.88,0,8.61,0,14.7,0,5.1,8.25,7.55.21,13.92,0,0,7.39-1.53,9-14.11C365.87,19.09,355.85,15.37,355.34,14.93Z"/></g></g></svg>
        </div>
        <div class="headline">
          <h1>Music for psychedelic therapy</h1>
        </div>
        <div class="controls">
          <svg v-if="!pauseTrack" @click="play()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 99.41"><circle class="circle-play" cx="49.7" cy="49.7" r="47.58" style="fill:none;stroke:#a8abaf;stroke-miterlimit:10;stroke-width:4.25196838378906px"/><path d="M43.79,27.45c-5.44-3.12-9.88-.55-9.88,5.72V66.24c0,6.26,4.39,8.75,9.76,5.52l28-16.85C77,51.68,77,46.49,71.54,43.37Z" style="fill:#6d6e71"/></svg>

          <svg v-else @click="fade()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 99.41"><rect x="33.86" y="33.86" width="31.68" height="31.68" rx="8.14" style="fill:#6d6e71"/><circle class="circle-stop active" cx="49.7" cy="49.7" r="47.58" style="fill:none;stroke:#a8abaf;stroke-miterlimit:10;stroke-width:4.25196838378906px"/></svg>

          <svg @click="nextButton ? fadeSkip() : ''" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 99.41"><path d="M60.25,39.1c0-.7,0-1.37,0-2s.48-1.05,1.15-.66q4.42,2.54,8.8,5.14c.73.43.63,1-.06,1.4-2.87,1.68-5.74,3.37-8.63,5-.81.46-1.24.15-1.26-.82,0-.6,0-1.2,0-1.79-3.68-.68-6.3.29-7.9,2.75-2,3.12-4.13,6.19-6.17,9.3a12.14,12.14,0,0,1-10.83,5.78c-1.81,0-3.62,0-5.43,0-.85,0-1.23-.33-1.21-1.21.05-1.2,0-2.41,0-3.62,0-.83.33-1.13,1.15-1.11,1.88,0,3.76,0,5.64,0a6.27,6.27,0,0,0,5.56-3c2.07-3.13,4.18-6.24,6.25-9.37a12.05,12.05,0,0,1,10.76-5.7l1.81,0a2.7,2.7,0,0,0,.37-.1" style="fill:#6d6e71"/><path d="M60.24,57.47c0-1,0-1.68,0-2.35s.47-1.13,1.18-.73q4.44,2.52,8.81,5.14c.68.41.57,1,0,1.34-2.92,1.73-5.86,3.45-8.81,5.13-.67.39-1.1.07-1.13-.69s0-1.33,0-2.17c-5.11.39-9.51-.81-12.61-5.2l3.56-5.35c1.13,1.64,2,3.55,4,4.12a40.55,40.55,0,0,0,5,.76" style="fill:#6d6e71"/><path d="M45.79,44.45l-3.57,5.34c-.41-.59-.79-1.12-1.14-1.67a6.23,6.23,0,0,0-5.55-3c-1.88,0-3.76,0-5.64,0-.89,0-1.21-.33-1.18-1.19,0-1.24-.06-2.49,0-3.73,0-.35.53-1,.8-1a74.43,74.43,0,0,1,9.22.38,10.53,10.53,0,0,1,7,4.8" style="fill:#6d6e71"/><circle class="circle-shuffle" cx="49.7" cy="49.7" r="47.58" style="fill:none;stroke:#a8abaf;stroke-miterlimit:10;stroke-width:4.25196838378906px"/></svg>
        </div>
      </div>
    </div>
  </div>
  <div class="section-two">
    <div class="container">
      <div class="row">
        <div class="column second-headline">
          <h2>Driven by technology,</h2>
          <h2>Inspired by nature.</h2>
        </div>
        <div class="column spacer">
          <!--blank-->
        </div>
      </div>
      <div class="row reverse">
        <div class="column">
          <img class="img-top" src="../assets/img/first.png" />
        </div>
        <div class="column text">
        <p><strong>HELD by sound</strong> utilizes knowledge in the fields of both music cognition and music production to provide intentionally crafted experiences that are made to support self-exploration and healing.</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {ref,reactive,computed} from 'vue';
import A1 from "@/music/A1.mp3";
import A2 from "@/music/A2.mp3";
import A3 from "@/music/A3.mp3";
import A4 from "@/music/A4.mp3";
import A5 from "@/music/A5.mp3";
import A6 from "@/music/A6.mp3";
import A7 from "@/music/A7.mp3";
import A8 from "@/music/A8.mp3";
import A9 from "@/music/A9.mp3";
import A10 from "@/music/A10.mp3";
import A11 from "@/music/A11.mp3";
import A12 from "@/music/A12.mp3";
import A13 from "@/music/A13.mp3";
import A14 from "@/music/A14.mp3";

import { Howl, Howler } from 'howler';


export default {

    mounted(){ 
      var sound = this.audios[this.index].howl;
          
    },

    setup(){

        const audios = ref([
            {file: A1,howl: null},
            {file: A2,howl: null},
            {file: A3,howl: null},
            {file: A4,howl: null},
            {file: A5,howl: null},
            {file: A6,howl: null},
            {file: A7,howl: null},
            {file: A8,howl: null},
            {file: A9,howl: null},
            {file: A10,howl: null},
            {file: A11,howl: null},
            {file: A12,howl: null},
            {file: A13,howl: null},
            {file: A14,howl: null},
                         
        ]);
        let skipIt = false;
        const nextButton = ref(true);
        const random = ref(true);
        const repeat = ref(true);
        const index = ref(0);
        const pauseTrack = ref(false);
        const state = reactive({
            audioPlaying: []
        })
        function play(){

            var sound;
            
            var audio = audios.value[index.value];
            if (audio.howl) {
                sound = audio.howl
            }else{
                state.audioPlaying[index.value] = false;
                sound = audio.howl =  new Howl({
                src: [audio.file],
                html5: true,
                format: ['mp3'],
                volume: 0,
                loop: true,
                onplay: function(){
                    sound.fade(sound.volume(),1,5000);
                    pauseTrack.value = true; 
                    nextButton.value = true;
                },
                onpause: function(){
                    pauseTrack.value = false;
                },
                onfade: function(){
                  if (sound.volume() == 0 && skipIt == true){
                    skipIt = false
                    next()
                  }else if (sound.volume() == 0){
                    pause()
                  }
                },
                onend: function() {
                  //next();
                },
                });
            }

            sound.play();

            state.audioPlaying[index.value] = true;

        }
        function fadeSkip(){
          if(pauseTrack.value == false){
            next()
          }else{
            skipIt = true
            var audio = audios.value[index.value].howl;
            audio.fade(audio.volume(),0,2000);
          }
        }
        function fade(){
          var audio = audios.value[index.value].howl;
          audio.fade(audio.volume(),0,250);

        }
        function pause(indexo){
            
            var audio = audios.value[index.value].howl;

            if (audio) {
                audio.pause();
                pauseTrack.value = false; 
                state.audioPlaying[index.value] = false;   
            }
            
        }
        function next() {

            nextButton.value = false;
            var audio = audios.value[index.value].howl;
            
            state.audioPlaying[index.value] = false;

            if ( audio && audios.value.length - 1 ==  index.value) {
                audio.stop();

                random.value ? index.value = Math.floor(Math.random() * audios.value.length)
                  
                : index.value = 0
            }else{    
                if (audio) {
                    audio.stop();
                }
                if(random.value){
                  let currentIndex = index.value
                  index.value = Math.floor(Math.random() * audios.value.length)
                  while(currentIndex == index.value){
                    index.value = Math.floor(Math.random() * audios.value.length)
                  }
                }else{
                  index.value = 0
                }
            }

            play();

        }    

        
        return{
            play,pause,audios,pauseTrack,next,index,state,random,repeat,nextButton,fade,fadeSkip, skipIt
        }
    }
}
</script>
